import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    enterLabResultSuccess, enterLabResultFailure,
    getLabResultByOrderSuccess, getLabResultByOrderFailure,
    getLabResultByPatientSuccess, getLabResultByPatientFailure,
    getLabResultTestHistorySuccess, getLabResultTestHistoryFailure,
    techValidateLabResultSuccess, techValidateLabResultFailure,
    batchTechValidateLabResultSuccess, batchTechValidateLabResultFailure,
    authorizeLabResultSuccess, authorizeLabResultFailure,
    batchAuthorizeLabResultSuccess, batchAuthorizeLabResultFailure,
    amendLabResultSuccess, amendLabResultFailure,
    criticalNotifyLabResultSuccess, criticalNotifyLabResultFailure,
    confirmContactLabResultSuccess, confirmContactLabResultFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* enterRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results`, requestDetail);
        yield put(enterLabResultSuccess(response));
    } catch (error) { yield put(enterLabResultFailure(error?.response?.message || error)); }
}

function* getByOrderRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/order/${action.payload}`, requestDetail);
        yield put(getLabResultByOrderSuccess(response));
    } catch (error) { yield put(getLabResultByOrderFailure(error?.response?.message || error)); }
}

function* getByPatientRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/patient/${action.payload}`, requestDetail);
        yield put(getLabResultByPatientSuccess(response));
    } catch (error) { yield put(getLabResultByPatientFailure(error?.response?.message || error)); }
}

function* getTestHistoryRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { patientId, testId } = action.payload;
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/patient/${patientId}/test/${testId}`, requestDetail);
        yield put(getLabResultTestHistorySuccess(response));
    } catch (error) { yield put(getLabResultTestHistoryFailure(error?.response?.message || error)); }
}

function* techValidateRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/${action.payload}/tech-validate`, requestDetail);
        yield put(techValidateLabResultSuccess(response));
    } catch (error) { yield put(techValidateLabResultFailure(error?.response?.message || error)); }
}

function* batchTechValidateRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/batch-tech-validate`, requestDetail);
        yield put(batchTechValidateLabResultSuccess(response));
    } catch (error) { yield put(batchTechValidateLabResultFailure(error?.response?.message || error)); }
}

function* authorizeRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/${id}/authorize`, requestDetail);
        yield put(authorizeLabResultSuccess(response));
    } catch (error) { yield put(authorizeLabResultFailure(error?.response?.message || error)); }
}

function* batchAuthorizeRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/batch-authorize`, requestDetail);
        yield put(batchAuthorizeLabResultSuccess(response));
    } catch (error) { yield put(batchAuthorizeLabResultFailure(error?.response?.message || error)); }
}

function* amendRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/${id}/amend`, requestDetail);
        yield put(amendLabResultSuccess(response));
    } catch (error) { yield put(amendLabResultFailure(error?.response?.message || error)); }
}

function* criticalNotifyRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/${id}/critical-notify`, requestDetail);
        yield put(criticalNotifyLabResultSuccess(response));
    } catch (error) { yield put(criticalNotifyLabResultFailure(error?.response?.message || error)); }
}

function* confirmContactRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/results/${id}/confirm-contact`, requestDetail);
        yield put(confirmContactLabResultSuccess(response));
    } catch (error) { yield put(confirmContactLabResultFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labResult/enterLabResultRequest', enterRequest);
    yield takeLatest('labResult/getLabResultByOrderRequest', getByOrderRequest);
    yield takeLatest('labResult/getLabResultByPatientRequest', getByPatientRequest);
    yield takeLatest('labResult/getLabResultTestHistoryRequest', getTestHistoryRequest);
    yield takeLatest('labResult/techValidateLabResultRequest', techValidateRequest);
    yield takeLatest('labResult/batchTechValidateLabResultRequest', batchTechValidateRequest);
    yield takeLatest('labResult/authorizeLabResultRequest', authorizeRequest);
    yield takeLatest('labResult/batchAuthorizeLabResultRequest', batchAuthorizeRequest);
    yield takeLatest('labResult/amendLabResultRequest', amendRequest);
    yield takeLatest('labResult/criticalNotifyLabResultRequest', criticalNotifyRequest);
    yield takeLatest('labResult/confirmContactLabResultRequest', confirmContactRequest);
}

export default saga;
